import React from 'react';
import PropTypes from 'prop-types';
import CssClassMixin from '../../mixins/css_class_mixin.jsx';
import UtilsMixin from '../../mixins/utils_mixin.jsx';

var createClass = require('create-react-class');

window.TableSelectCell = createClass({
  mixins: [CssClassMixin, UtilsMixin],

  propTypes: {
    rowId: PropTypes.string,
    cellElement: PropTypes.string,
    dataRowIds: PropTypes.array,
    selected: PropTypes.bool,
    onSelectToggle: PropTypes.func
  },

  getDefaultProps: function() {
    return {
      themeClassKey: 'table.select',
      className: 'table-select',
      rowId: '',
      cellElement: 'td',
      dataRowIds: [],
      selected: false,
      onSelectToggle: function(event, dataRows, selected) {}
    };
  },

  render: function() {
    return (
      React.createElement(this.props.cellElement,
        { className: this.className() },
        [
          <InputCheckbox id={this.getCheckboxId()} checked={this.props.selected} key={this.generateUUID()} />,
          <Label id={this.getCheckboxId()} key="label" onClick={this.handleChange} />
        ]
      )
    );
  },

  getCheckboxId: function() {
    return "select_" + String(this.props.rowId);
  },

  handleChange: function(event) {
    this.props.onSelectToggle(event, this.props.dataRowIds, !this.props.selected);
    event.stopPropagation();
  }
});